/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { PRODUCT_IDS } from "utils/constants";
import { useQuery } from "@apollo/react-hooks";
import Loading from "components/common/SimpleLoading";
import { Link, useHistory } from "react-router-dom";
import { USER_CREDIT_SCORE_QUERY } from "components/Pages/Boost/mutations";
import CreditScoreChart from "../Dashboard/CreditScore/CreditScoreChart";
import { ProductCardDefault } from "./ProductCardDefault";
import { PRODUCT_CARD_DEFAULT_CONFIG } from "./const";
import { getButtonClassName, parseDateToDaysAgo } from "./utils";

export const CreditMonitoringSnapshot = ({ belowBreakpoint, redirectUrl }) => {
  const history = useHistory();
  const queryOptions = {
    variables: {
      bureau: "TransUnion",
      order: "DESC",
      limit: 1,
    },
  };
  const creditMonitoringConfig = PRODUCT_CARD_DEFAULT_CONFIG[PRODUCT_IDS.CREDIT_MONITORING];
  const { loading, error, data } = useQuery(USER_CREDIT_SCORE_QUERY, queryOptions);
  const [latestCreditScore = {}] = data?.getUserCreditScore?.credit_scores || [];
  const {
    date_pulled_at: datePulledAt,
    // credit_scoring_model: creditScoringModel,
  } = latestCreditScore;
  const parsedDaysAgo = parseDateToDaysAgo(datePulledAt);

  if (loading) {
    return <Loading />;
  }
  if (error) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ProductCardDefault {...creditMonitoringConfig} />;
  }
  return (
    <div
      className="p-5 md:p-10 flex flex-col items-center justify-start flex-1 border rounded-md overflow-hidden border-neutral-300 hover:border-neutral-700 bg-white relative"
      onClick={() => belowBreakpoint && history.push(redirectUrl) }
    >
      <div className="text-2xl font-bold self-start">Credit monitor</div>
      <div className="mt-5 p-2 pt-5 md:p-5 lg:p-10 w-full bg-neutral-50 flex justify-center">
        <CreditScoreChart creditScore={latestCreditScore} />
      </div>
      <div className="mt-4 text-2xl font-bold">Your credit score</div>
      {parsedDaysAgo && <div className="mt-4 text-2xl font-bold" style={{ color: "#006E65" }}>{parsedDaysAgo}</div>}
      <div className="mt-4 text-xs font-semibold mdl:pb-16">We check for updates once a month</div>
      {!belowBreakpoint && <div className="mb-10 absolute bottom-0 left-0 w-full">
        <Link
          to={creditMonitoringConfig.redirectUrl}
          className={getButtonClassName("mx-auto")}
          style={{ maxWidth: 202 }}
        >
          {creditMonitoringConfig.buttonText}
        </Link>
      </div>}
    </div>
  );
};